import classnames from "classnames";
import { motion } from "framer-motion";
import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { TOPBAR_ANIMATE, TOPBAR_TRANSITION } from "@/core/animations";

import { Footer, Topbar } from "./components";

import "./_public-layout.scss";

interface Props {
  className?: string;
  stickyTopbar?: boolean;
  transparentTopbar?: boolean;
  borderBottomTopbar?: boolean;
  hideTopbar?: boolean;
  hideFooter?: boolean;
  slideInTopbar?: boolean;
}

const baseClass = "public-layout";

export const PublicLayout: FC<Props> = memo(
  ({
    className,
    children,
    stickyTopbar = true,
    transparentTopbar = false,
    hideTopbar = true,
    hideFooter = true,
    slideInTopbar = false,
  }) => {
    const { ready } = useTranslation(["common", "public", "session", "codelists"]);

    const renderTopBar = () => {
      if (!stickyTopbar) {
        return (
          <motion.div animate={slideInTopbar ? TOPBAR_ANIMATE : undefined} transition={TOPBAR_TRANSITION}>
            <Topbar transparent={transparentTopbar} showNavigation />
          </motion.div>
        );
      }

      return (
        <div className={`${baseClass}__topbar-wrapper`}>
          <Topbar transparent={transparentTopbar} showNavigation />
        </div>
      );
    };

    return (
      <>
        <div className={classnames(baseClass, className)}>
          {!hideTopbar && ready && renderTopBar()}
          <div className={`${baseClass}__content-wrapper`}>{ready && children}</div>
          {!hideFooter && ready && (
            <div className={`${baseClass}__footer-wrapper`}>
              <Footer />
            </div>
          )}
        </div>
      </>
    );
  },
);
